import { useMemo } from "react";
import {
  getFilteredRegistros,
  calculateStats,
  calculateChartData,
} from "../services/calculations";

/**
 * Custom hook: Calculate all statistics
 */
export const useStats = (
  registros,
  tournaments,
  filters,
  activeFilters,
  currencyOptions
) => {
  const filtered = useMemo(() => {
    return getFilteredRegistros(registros, tournaments, filters);
  }, [registros, tournaments, filters]);

  const stats = useMemo(() => {
    const source = activeFilters ? filtered : registros;
    return calculateStats(source, tournaments, currencyOptions);
  }, [filtered, registros, tournaments, activeFilters, currencyOptions]);

  return { filtered, stats };
};

/**
 * Custom hook: Calculate chart data
 */
export const useChartData = (
  filtered,
  registros,
  tournaments,
  activeFilters,
  showWithoutSat,
  currencyOptions
) => {
  return useMemo(() => {
    const source = activeFilters ? filtered : registros;
    return calculateChartData(source, tournaments, showWithoutSat, currencyOptions);
  }, [
    filtered,
    registros,
    tournaments,
    activeFilters,
    showWithoutSat,
    currencyOptions,
  ]);
};

/**
 * Custom hook: Paginated slice of data
 */
export const usePaginatedData = (filtered, page, pageSize) => {
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const safePage = Math.min(page, totalPages);

  const pageSlice = useMemo(() => {
    const start = (safePage - 1) * pageSize;
    return filtered.slice(start, start + pageSize);
  }, [filtered, safePage, pageSize]);

  return { totalPages, safePage, pageSlice };
};
